import React from 'react';
import HelpBubble from 'js/components/help_bubble';

export default function FormLabel(props) {
    const {optional, helpText, multiline, place, inline} = props;
    const label = props.children || (
            <span className={props.className}>
                {props.label} 
            </span>
    );
    return (
        <div>
            {label}
            {optional}
            &nbsp;
            {helpText && (
                <HelpBubble text={helpText} multiline={multiline} place={place} inline={inline} />
            )}
        </div>
    );
}

FormLabel.displayName = 'FormLabel';



// WEBPACK FOOTER //
// ./form_components/form_label.js